var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "b-list-group",
            _vm._l(_vm.configurations, function(configuration) {
              return _c(
                "b-list-group-item",
                {
                  key: configuration.id,
                  staticClass: "flex-column align-items-start"
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex w-100 justify-content-between" },
                    [
                      _c("h5", { staticClass: "mb-1 text-secundary" }, [
                        _vm._v(" " + _vm._s(configuration.title) + " ")
                      ])
                    ]
                  ),
                  configuration.type === "sino"
                    ? _c(
                        "b-card-text",
                        { staticClass: "mb-1" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn-block btn-primary",
                              on: {
                                click: function($event) {
                                  return _vm.toggleSiNo(configuration)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("capitalize")(configuration.value)
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : configuration.type === "correomultiple"
                    ? _c("b-card-text", { staticClass: "mb-1" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: configuration.value,
                              expression: "configuration.value"
                            }
                          ],
                          staticClass: "form-control",
                          domProps: { value: configuration.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                configuration,
                                "value",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : configuration.type === "opciones"
                    ? _c("b-card-text", { staticClass: "mb-1" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: configuration.value,
                                expression: "configuration.value"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "select" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  configuration,
                                  "value",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          _vm._l(configuration.extra.opciones, function(
                            option
                          ) {
                            return _c(
                              "option",
                              {
                                key: option.valor,
                                domProps: { value: option.valor }
                              },
                              [_vm._v(" " + _vm._s(option.descripcion) + " ")]
                            )
                          }),
                          0
                        )
                      ])
                    : configuration.type === "usuarios"
                    ? _c(
                        "b-card-text",
                        { staticClass: "mb-1" },
                        [
                          _c("ListUser", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100 mb-0",
                            attrs: {
                              autocomplete: "",
                              label: "",
                              name: "user",
                              "data-vv-as": "usuario"
                            },
                            model: {
                              value: configuration.value,
                              callback: function($$v) {
                                _vm.$set(configuration, "value", $$v)
                              },
                              expression: "configuration.value"
                            }
                          })
                        ],
                        1
                      )
                    : configuration.type === "perfiles"
                    ? _c(
                        "b-card-text",
                        { staticClass: "mb-1" },
                        [
                          _c("ListProfiles", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100 mb-0",
                            attrs: {
                              autocomplete: "",
                              label: "",
                              name: "perfiles",
                              "data-vv-as": "perfil"
                            },
                            model: {
                              value: configuration.value,
                              callback: function($$v) {
                                _vm.$set(configuration, "value", $$v)
                              },
                              expression: "configuration.value"
                            }
                          })
                        ],
                        1
                      )
                    : configuration.type === "opcionesaprobaciones"
                    ? _c(
                        "b-card-text",
                        { staticClass: "mb-1" },
                        [
                          _c("ListAprovals", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100 mb-0",
                            attrs: {
                              autocomplete: "",
                              label: "",
                              name: "apronvals",
                              reference: _vm.reference,
                              "data-vv-as": "usuario"
                            },
                            model: {
                              value: configuration.value,
                              callback: function($$v) {
                                _vm.$set(configuration, "value", $$v)
                              },
                              expression: "configuration.value"
                            }
                          })
                        ],
                        1
                      )
                    : configuration.type === "textomail"
                    ? _c(
                        "b-card-text",
                        { staticClass: "mb-1" },
                        [
                          _c("b-form-textarea", {
                            model: {
                              value: configuration.value,
                              callback: function($$v) {
                                _vm.$set(configuration, "value", $$v)
                              },
                              expression: "configuration.value"
                            }
                          })
                        ],
                        1
                      )
                    : configuration.type === "pasosejecucion"
                    ? _c("div", { staticClass: "mb-1" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-3" },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Tipo de paso" } },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: configuration.stepType,
                                          expression: "configuration.stepType"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "stepType",
                                        name: "stepType"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            configuration,
                                            "stepType",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.stepTypesCodes.USER
                                          }
                                        },
                                        [_vm._v("Usuario ")]
                                      ),
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.stepTypesCodes.GROUP
                                          }
                                        },
                                        [_vm._v("Grupo ")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          configuration.stepType === _vm.stepTypesCodes.GROUP
                            ? _c(
                                "div",
                                { staticClass: "col-12 col-md-4" },
                                [
                                  _c("list-groups", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required:
                                            configuration.stepType ===
                                            _vm.stepTypesCodes.GROUP
                                        },
                                        expression:
                                          "{ required: configuration.stepType === stepTypesCodes.GROUP }"
                                      }
                                    ],
                                    ref: "groupStep",
                                    refInFor: true,
                                    attrs: {
                                      autocomplete: "",
                                      label: "Grupo del responsable",
                                      name: "groupStep",
                                      typeList: configuration.stepType,
                                      danger: _vm.errors.has("steps.groupStep"),
                                      "danger-text": _vm.errors.first(
                                        "steps.groupStep"
                                      )
                                    },
                                    model: {
                                      value: configuration.groupStep,
                                      callback: function($$v) {
                                        _vm.$set(
                                          configuration,
                                          "groupStep",
                                          $$v
                                        )
                                      },
                                      expression: "configuration.groupStep"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          configuration.stepType != _vm.stepTypesCodes.GROUP
                            ? _c(
                                "div",
                                { staticClass: "col-12 col-md-4" },
                                [
                                  _c("list-user", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required:
                                            configuration.stepType ===
                                            _vm.stepTypesCodes.USER
                                        },
                                        expression:
                                          "{ required: configuration.stepType === stepTypesCodes.USER }"
                                      }
                                    ],
                                    ref: "userStep",
                                    refInFor: true,
                                    attrs: {
                                      autocomplete: "",
                                      label: "Usuario",
                                      name: "userStep",
                                      danger: _vm.errors.has("steps.userStep"),
                                      "danger-text": _vm.errors.first(
                                        "steps.userStep"
                                      )
                                    },
                                    model: {
                                      value: configuration.userStep,
                                      callback: function($$v) {
                                        _vm.$set(configuration, "userStep", $$v)
                                      },
                                      expression: "configuration.userStep"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-3" },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Tipo de paso" } },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: configuration.rolType,
                                          expression: "configuration.rolType"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "stepType",
                                        name: "stepType"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            configuration,
                                            "rolType",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.rolTypesCodes.APPROVER
                                          }
                                        },
                                        [_vm._v(" Aprobador ")]
                                      ),
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.rolTypesCodes.REVIEWER
                                          }
                                        },
                                        [_vm._v(" Revisor ")]
                                      ),
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.rolTypesCodes.SIGNER
                                          }
                                        },
                                        [_vm._v(" Firmante ")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-2 d-flex mt-8" },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("vs-button", {
                                    attrs: { color: "primary", icon: "add" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addStep(configuration)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(configuration.value, function(step, index) {
                            return _c(
                              "div",
                              {
                                key: "step-" + index,
                                staticClass: "col-12 col-md-4"
                              },
                              [
                                _c("div", { staticClass: "step-wrapper" }, [
                                  _c("span", { staticClass: "step-number" }, [
                                    _vm._v(_vm._s(index + 1))
                                  ]),
                                  !_vm.readonly
                                    ? _c(
                                        "span",
                                        { staticClass: "step-delete" },
                                        [
                                          _c("vs-icon", {
                                            attrs: {
                                              icon: "highlight_off",
                                              size: "small",
                                              bg: "white",
                                              color: "danger",
                                              round: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.removeStep(
                                                  configuration,
                                                  index
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "cursor-default text-center step-name"
                                    },
                                    [_vm._v(" " + _vm._s(step.nombre) + " ")]
                                  ),
                                  _c("div", { staticClass: "step-types" }, [
                                    +step.tipoPasoId === _vm.stepTypesCodes.USER
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "bg-secondary badges"
                                          },
                                          [_vm._v(" Usuario ")]
                                        )
                                      : _vm._e(),
                                    +step.tipoPasoId ===
                                    _vm.stepTypesCodes.GROUP
                                      ? _c(
                                          "span",
                                          { staticClass: "blue badges" },
                                          [_vm._v(" Grupo ")]
                                        )
                                      : _vm._e()
                                  ]),
                                  _c("div", { staticClass: "step-roles" }, [
                                    +step.rolId === _vm.rolTypesCodes.APPROVER
                                      ? _c(
                                          "span",
                                          { staticClass: "bg-info badges" },
                                          [_vm._v(" Aprobador ")]
                                        )
                                      : _vm._e(),
                                    +step.rolId === _vm.rolTypesCodes.SIGNER
                                      ? _c(
                                          "span",
                                          { staticClass: "bg-success badges" },
                                          [_vm._v(" Firmante ")]
                                        )
                                      : _vm._e(),
                                    +step.rolId === _vm.rolTypesCodes.REVIEWER
                                      ? _c(
                                          "span",
                                          { staticClass: "bg-warning badges" },
                                          [_vm._v(" Revisor ")]
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    : configuration.type === "info"
                    ? _c("b-card-text", { staticClass: "mb-1" }, [
                        _vm._v(" " + _vm._s(configuration.value) + " ")
                      ])
                    : _c("b-card-text", { staticClass: "mb-1" }, [
                        _vm._v(" No soportado el tipo : "),
                        _c("strong", [_vm._v(_vm._s(configuration.type))])
                      ])
                ],
                1
              )
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "error-message mt-3 text-danger text-right" },
            [_c("span", [_vm._v(" " + _vm._s(_vm.errorConsequence) + " ")])]
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row text-center" }, [
      _c("div", { staticClass: "col-12 col-md-6" }, [
        _c(
          "button",
          {
            staticClass: "mt-3 btn btn-danger",
            attrs: { block: "" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_vm._v("Cancelar")]
        )
      ]),
      _c("div", { staticClass: "col-12 col-md-6" }, [
        _c(
          "button",
          {
            staticClass: "mt-3 btn btn-primary",
            attrs: { block: "" },
            on: { click: _vm.configurar }
          },
          [_vm._v("Configurar")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }